import { render } from "./CandlePreview.vue?vue&type=template&id=c40076f6&scoped=true"
import script from "./CandlePreview.vue?vue&type=script&lang=js"
export * from "./CandlePreview.vue?vue&type=script&lang=js"

import "./CandlePreview.vue?vue&type=style&index=0&id=c40076f6&scoped=true&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c40076f6"]])

export default __exports__